import { routeSlugFromIdentifierAndTitle } from '@/js/core/utils/route-slug';

/**
 * Match a calendar event against the detail route slug used by the backend.
 */
export function matchesCalendarEventPageSlug(event, eventPageSlug) {
  const incomingSlugs = calendarEventPageSlugVariants(eventPageSlug);
  const serviceApiIds = calendarEventServiceApiIds(event);
  const routeSlugs = serviceApiIds.map(id => calendarEventRouteSlugFromValues(id, event.title));
  const candidateSlugs = [event.event_page_slug, ...serviceApiIds, ...routeSlugs].flatMap(value =>
    calendarEventPageSlugVariants(value)
  );

  return candidateSlugs.some(value => incomingSlugs.includes(value));
}

/**
 * Build the frontend equivalent of the backend event route slug.
 */
export function calendarEventRouteSlugFromValues(eventId, title) {
  return routeSlugFromIdentifierAndTitle(eventId, title);
}

export function normalizeCalendarEventPageSlug(eventPageSlug) {
  return calendarEventPageSlugVariants(eventPageSlug)[0] || '';
}

/**
 * The leading Services API id from a route slug — for an occurrence slug that's
 * the occurrence id, which the modal uses to scope to its group.
 */
export function serviceApiIdFromCalendarEventPageSlug(eventPageSlug) {
  const slug = normalizeCalendarEventPageSlug(eventPageSlug);
  const match = slug.match(/^([a-z0-9]+)(?:-|$)/i);

  return match ? match[1] : '';
}

function calendarEventPageSlugVariants(value) {
  const slug = trimRouteSlug(value);

  if (!slug) return [];

  return Array.from(new Set([safeDecodeRouteSlug(slug), slug].filter(Boolean)));
}

function trimRouteSlug(value) {
  return String(value || '')
    .trim()
    .replace(/^\/+|\/+$/g, '');
}

function safeDecodeRouteSlug(slug) {
  try {
    return decodeURIComponent(slug);
  } catch {
    return slug;
  }
}

function calendarEventServiceApiIds(event) {
  const occurrenceIds = Array.isArray(event.occurrences)
    ? event.occurrences.flatMap(occurrence => [
        occurrence.gsd_service_api_id,
        ...(occurrence.gsd_service_api_ids || []),
      ])
    : [];

  return [event.gsd_service_api_id, ...occurrenceIds].filter(
    value => value !== undefined && value !== null && value !== ''
  );
}
